import React from 'react'
import './ShowTeamAppointment.css'
import { Input, Icon, Button, Form, DatePicker } from 'antd'
// import Cookies from 'js-cookie' // js-cookie
import faildImg from '@/img/faild.png'
import successImg from '@/img/success.png'
import request from '@/utils/request'
import { getKey } from '@/utils/Cookie'
const FormItem = Form.Item
const { RangePicker } = DatePicker

class ShowTeamAppointment extends React.Component {
  state = {
    ArrayMessage: {},
    status: null
  }
  componentWillMount() {
    const CookieTeamMessage = getKey('TeamMessage')?JSON.parse(getKey('TeamMessage')):null
    // console.log(JSON.parse(getKey('TeamMessage')))
    if(CookieTeamMessage){
      this.setState({
        ArrayMessage: CookieTeamMessage,
        status: CookieTeamMessage.status
      })
    }

    const busName = getKey('businessLicenseNumber')
      ? getKey('businessLicenseNumber')
      : null
    if (busName) {
      this.getMessage(busName)
    }
  }
  getMessage(data) {
    request
      .get(`/v1/mobile/reserve/group/info?businessLicenseNumber=${data}`)
      .then(res => {
        // console.log('res')
        // console.log(res)
        this.setState({
          ArrayMessage: res.data,
          status: res.data.status
        })
      })
  }
  Record() {
    // console.log('123')
    this.props.history.push('/Main/Team/RegisteredTeam')
  }
  render() {
    const { ArrayMessage, status } = this.state
    return (
      <div className="ShowTeamAppointment">
        <div className="ShowTeamAppointment_conten">
          <div className="img">
            {status == 1 ? (
              <img src={successImg}></img>
            ) : status == 3 ? (
              <img src={faildImg}></img>
            ) : null}
          </div>
          <div className="text">
            {status == 1
              ? '提交成功，等待审核'
              : status == 3
              ? '审核未通过'
              : null}
          </div>
          <div className="messageContent">
            {status == 3 ? (
              <div className="error">
                未通过原因：
                <span>{ArrayMessage.description}</span>
              </div>
            ) : null}

            <div className="item">
              <span>企事业单位名称：</span>
              <span>{ArrayMessage.businessLicenseName}</span>
            </div>
            <div className="item">
              <span>社会统一信用代码：</span>
              <span>{ArrayMessage.businessLicenseNumber}</span>
            </div>
            <div className="item">
              <span>营业执照：</span>
              <img
                style={{ width: '224px', height: '139px' }}
                src={ArrayMessage.businessLicenseUrl}
              ></img>
            </div>
            <div className="item">
              <span>联系人姓名：</span>
              <span>{ArrayMessage.leaderName}</span>
            </div>
            <div className="item">
              <span>联系人身份证号：</span>
              <span>{ArrayMessage.leaderIdcard}</span>
            </div>
            <div className="item">
              <span>身份证图片：</span>
              <img
                style={{ width: '224px', height: '139px' }}
                src={ArrayMessage.leaderIdcardPositive}
              ></img>
            </div>
            <div className="item">
              <span>团队预留邮箱：</span>
              <span>{ArrayMessage.businessLicenseEmail}</span>
            </div>
            <div className="item">
              <span>联系人电话：</span>
              <span>{ArrayMessage.leaderMobile}</span>
            </div>
          </div>
          {status == 3 ? (
            <div className="buttonConten">
              <div className="buttonConten_right" onClick={el => this.Record()}>
                重新提交资料
              </div>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}
export default ShowTeamAppointment
